import { Wizard } from "@/archetypes/Wizard";
export function ReferenceWizardPage() {
  return (
    <Wizard
      steps={[
        { id: "step-1", label: "Step 1", render: () => <p>First step</p> },
        { id: "step-2", label: "Step 2", render: () => <p>Second step</p> },
        { id: "step-3", label: "Step 3", render: () => <p>Third step</p> },
      ]}
      onSaveDraft={() => undefined}
      onFinish={() => undefined}
    />
  );
}
